import { motion } from "framer-motion";
import { FaLinkedin, FaGithub, FaTelegram } from "react-icons/fa";
import profile from "../_data/profile.json";

const icons = { LinkedIn: FaLinkedin, GitHub: FaGithub, Telegram: FaTelegram };

/**
 * Represents a component displaying social media icons.
 *
 * This component displays social media icons with animation effects.
 *
 * @component
 */

const SocialIcons = () => (
  <div className="socialIcons">
    {profile.socials.map((social, i) => {
      const Icon = icons[social.name];
      return (
        <motion.a
          key={social.name}
          className="icon"
          href={social.url}
          target="_blank"
          rel="me noopener noreferrer"
          aria-label={`${profile.name} on ${social.name}`}
          title={`${profile.name} on ${social.name}`}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 + i * 0.1, duration: 0.5, type: "spring" }}
        >
          <Icon aria-hidden="true" />
        </motion.a>
      );
    })}
  </div>
);

export default SocialIcons;
